import { ImageComponentModule } from './../image-component/image-component.module';
import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { GdMenuPage } from './gd-menu';
import { FlexLayoutModule } from '@angular/flex-layout';
import { HammerGestureConfig, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import * as Hammer from 'hammerjs';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { GdAvatarPageModule } from '../gd-avatar/gd-avatar.module';
import { ListMultiAccountPageModule } from '../../pages/general/home2/list-multi-account/list-multi-account.module';

export class CustomHammerConfig extends HammerGestureConfig{
  overrides = {
    'pan': {
      direction: Hammer.DIRECTION_ALL
    },
    'swipe': {
      direction: Hammer.DIRECTION_DOWN
    }
  }
}
@NgModule({
  declarations: [
    GdMenuPage,
  ],
  imports: [
    IonicPageModule.forChild(GdMenuPage),
    TranslateModule.forChild(),
    FlexLayoutModule,
    ImageComponentModule,
    GdAvatarPageModule,
    AngularSvgIconModule,
    ListMultiAccountPageModule
  ],
  exports: [
    GdMenuPage
  ],
  providers: [
    { provide: HAMMER_GESTURE_CONFIG, useClass: CustomHammerConfig}
  ],
})
export class GdMenuPageModule {}



// WEBPACK FOOTER //
// ./src/components/gd-menu/gd-menu.module.ts